import styled from 'styled-components';

export const Container = styled.div`
  .title {
    color: ${(props) => props.theme.$gray600};
  }
`;
